import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import Vue from 'vue';
import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils';
import NuxtError from '../layouts/error.vue';
import NuxtLoading from './components/nuxt-loading.vue';
import '../node_modules/@web/shared-digital-library/css/custom-grid.css';
import '../node_modules/@web/shared-digital-library/css/fluid-font.css';
import '../assets/scss/app.scss';
var _77180f1e = () => import('../layouts/blank.vue' /* webpackChunkName: "layouts/blank" */).then(m => sanitizeComponent(m.default || m));
var _996cf988 = () => import('../layouts/checkout.vue' /* webpackChunkName: "layouts/checkout" */).then(m => sanitizeComponent(m.default || m));
var _6f6c098b = () => import('../layouts/default.vue' /* webpackChunkName: "layouts/default" */).then(m => sanitizeComponent(m.default || m));
var _77430317 = () => import('../layouts/empty.vue' /* webpackChunkName: "layouts/empty" */).then(m => sanitizeComponent(m.default || m));
var resolvedLayouts = {};
var layouts = {
  "_blank": _77180f1e,
  "_checkout": _996cf988,
  "_default": _6f6c098b,
  "_empty": _77430317
};
export default {
  render(h, props) {
    var loadingEl = h('NuxtLoading', {
      ref: 'loading'
    });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);
    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll');
          });
        }
      }
    }, [templateEl]);
    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: '',
    nbFetching: 0
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created() {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this;
    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this;
      this.refreshOnlineStatus();
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus);
      window.addEventListener('offline', this.refreshOnlineStatus);
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
    // Add $nuxt.context
    this.context = this.$options.context;
  },
  mounted() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this.$loading = _this.$refs.loading;
    })();
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  computed: {
    isOffline() {
      return !this.isOnline;
    },
    isFetching() {
      return this.nbFetching > 0;
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true;
        } else {
          this.isOnline = window.navigator.onLine;
        }
      }
    },
    refresh() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        var pages = getMatchedComponentsInstances(_this2.$route);
        if (!pages.length) {
          return;
        }
        _this2.$loading.start();
        var promises = pages.map(page => {
          var p = [];

          // Old fetch
          if (page.$options.fetch && page.$options.fetch.length) {
            p.push(promisify(page.$options.fetch, _this2.context));
          }
          if (page.$fetch) {
            p.push(page.$fetch());
          } else {
            // Get all component instance to call $fetch
            for (var component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
              p.push(component.$fetch());
            }
          }
          if (page.$options.asyncData) {
            p.push(promisify(page.$options.asyncData, _this2.context).then(newData => {
              for (var key in newData) {
                Vue.set(page.$data, key, newData[key]);
              }
            }));
          }
          return Promise.all(p);
        });
        try {
          yield Promise.all(promises);
        } catch (error) {
          _this2.$loading.fail(error);
          globalHandleError(error);
          _this2.error(error);
        }
        _this2.$loading.finish();
      })();
    },
    errorChanged() {
      var _this3 = this;
      return _asyncToGenerator(function* () {
        if (_this3.nuxt.err) {
          if (_this3.$loading) {
            if (_this3.$loading.fail) {
              _this3.$loading.fail(_this3.nuxt.err);
            }
            if (_this3.$loading.finish) {
              _this3.$loading.finish();
            }
          }
          var errorLayout = (NuxtError.options || NuxtError).layout;
          if (typeof errorLayout === 'function') {
            errorLayout = errorLayout(_this3.context);
          }
          yield _this3.loadLayout(errorLayout);
          _this3.setLayout(errorLayout);
        }
      })();
    },
    setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) {
        layout = 'default';
      }
      this.layoutName = layout;
      var _layout = '_' + layout;
      this.layout = resolvedLayouts[_layout];
      return this.layout;
    },
    loadLayout(layout) {
      var undef = !layout;
      var nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout]);
      var _layout = '_' + (undef || nonexistent ? 'default' : layout);
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout]);
      }
      return layouts[_layout]().then(Component => {
        resolvedLayouts[_layout] = Component;
        delete layouts[_layout];
        return resolvedLayouts[_layout];
      }).catch(e => {
        if (this.$nuxt) {
          return this.$nuxt.error({
            statusCode: 500,
            message: e.message
          });
        }
      });
    }
  },
  components: {
    NuxtLoading
  }
};